import angular from 'angular';
import { default as reportsDataService } from 'app/services/data/reports.data.service';
import generateReportsDialog from './generateReportsDialog';
import controller from './generate-reports-list.controller';
import directive from './generate-reports-list.directive';

const library = require('@safe-systems/ss-ui-components');

const {
  loaderService,
  ssDialogService,
} = library;

export default angular.module('app.components.global.appReports', [
  generateReportsDialog,
  loaderService,
  reportsDataService,
  ssDialogService,
])
  .directive('generateReportsList', directive)
  .controller('GenerateReportsListController', controller)
  .name;

console.log('app.components.global.appReports created');
